import React, { Component, push } from "react";
import {
  Grommet,
  Box,
  Text,
  DataTable,
  Spinner,
  Layer,
  Button,
  Heading,
  Grid,
  Card,
  Header,
  //StarRating,
  TextInput,
  Main,
} from "grommet";
import {
  Close,
  FormPrevious,
  Console,
  Validate,
  Return,
  Codepen,
  Video,
  Gateway,
  // StarRating,
} from "grommet-icons";
import Alert from "@material-ui/lab/Alert";
import { hpe as theme } from "grommet-theme-hpe";
import Rating from "@material-ui/lab/Rating";
import auth from "./Security/Auth";
import { callApiGetJson, callApiPostJson } from "./GlobalSettings";
import ScaleLoader from "react-spinners/ScaleLoader";

class RatingFeedback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSeatLoader: true,
      Evt: undefined, //this.props.Evts[0],
      MM: undefined, //this.props.MMs !== null ? this.props.MMs[0] : undefined,
      showLoaderRating: false,
      showLoaderRatingMM: false,
      OppID: undefined,
      isOppIDValidated: false,
      OppIDvalidatedLoader: false,
      showOppIDAlert: false,
      EvtFeedback: undefined,
      MMFeedback: undefined,
      oppIDMessage: "None",
      showLoaderEvtSubmit: false,
      isEvtSubmitted: false,
      showLoaderMMSubmit: false,
      isMMSubmitted: false,
    };

    this.setRatingEvt = this.setRatingEvt.bind(this);
    this.setRatingMM = this.setRatingMM.bind(this);
    this.handleOppID = this.handleOppID.bind(this);
    this.validateOppID = this.validateOppID.bind(this);
    this.handleFeedbackEvt = this.handleFeedbackEvt.bind(this);
    this.handleFeedbackMM = this.handleFeedbackMM.bind(this);
    this.submitEvtUpdate = this.submitEvtUpdate.bind(this);
    this.submitMMUpdate = this.submitMMUpdate.bind(this);
  }

  componentDidMount() {
    auth.setRecentEvtsMMPopUpCounter("yes");
    console.log("Recent Events by this Usr are ", this.props.Evts);
    console.log("Recent Videos by this Usr are ", this.props.MMs);
    let Evvt =
      this.props.Evts != null || this.props.Evts != undefined
        ? this.props.Evts[0]
        : undefined;
    let MMM =
      this.props.MMs != null || this.props.MMs != undefined
        ? this.props.MMs[0]
        : undefined;
    this.setState({ Evt: Evvt, MM: MMM });
  }

  closeOppIDALert() {
    this.setState({ showOppIDAlert: false });
  }

  validateOppID() {
    console.log("_onSFDCOpptyIdChange - value: " + this.state.OppID);
    //this.oppoIdChecked = true;
    if (this.state.OppID) {
      if (this.state.OppID.length < 20 && this.state.OppID.length > 2) {
        this.setState({ OppIDvalidatedLoader: true });
        //don't call this unless they actually put something in there.
        var endpoint = "/SFDC/GetSFDCValidation?OptyId=" + this.state.OppID;
        let token = auth.getToken();

        callApiGetJson(endpoint, token).then((data) => {
          if (data !== undefined) {
            console.log(data);

            if (data.SRC_OPTY_SHRT_UID != null) {
              var Event_OpportunityID = data.SRC_OPTY_SHRT_UID;

              this.setState({
                // Event_OpportunityID: Event_OpportunityID,
                OppID: Event_OpportunityID,
                OppIDvalidatedLoader: false,
                isOppIDValidated: true,
                showOppIDAlert: true,
                oppIDMessage: "GREAT",
                // stickMessage: "Validation Successful",
                //  SubmitLabel: "Validation Successful",
              });
            } else {
              var Event_OpportunityID = undefined;
              this.setState({
                //message: data.Message[0], //keep validating screen up so they see userMessage.
                // stickMessage: data.Message[0],
                OppIDvalidatedLoader: false,
                OppID: Event_OpportunityID,
                isOppIDValidated: false,
                showOppIDAlert: true,
                oppIDMessage: "FAILED",
                // SubmitLabel: "Invalid-OPP ID",
                // Event_OpportunityID: Event_OpportunityID,
              });
            }
          } else {
            var Event_OpportunityID = undefined;
            this.setState({
              OppID: Event_OpportunityID,
              OppIDvalidatedLoader: false,
              showOppIDAlert: true,
              oppIDMessage: "FAILED",
              //message: "Error validating SFDC OPP ID.",
              // stickMessage: "Error validating SFDC OPP ID.",
              isOppIDValidated: false,
            });
          }
        });
      }
    }
  }

  handleFeedbackEvt(val) {
    console.log("Feedback is with value ", val);
    if (val.length > 1) {
      this.setState({ EvtFeedback: val });
    }
  }

  handleFeedbackMM(vval) {
    console.log("Feedback is with value ", vval);
    if (vval.length > 1) {
      this.setState({ MMFeedback: vval });
    }
  }

  handleOppID(value) {
    console.log("OPP ID Changed with value ", value);
    if (value.length > 3) {
      this.setState({ OppID: value });
    }
    // this.setState({ OppID: value });
  }

  submitEvtUpdate() {
    console.log("Event ID is ", this.props.Evts[0].Event_ID);
    console.log("Submit Type is Event");
    console.log("Event Opp ID is ", this.state.OppID);
    console.log("Event Feedback is ", this.state.Evt.Event_Feedback);
    console.log("Is Evt Opp ID Validated", this.state.isOppIDValidated);

    let OppporID = null;
    if (this.state.isOppIDValidated) {
      console.log("Opp ID validated ");
      OppporID = this.state.OppID;
    } else {
      console.log("Opp ID Not validated");
      OppporID = this.props.Evts[0].Event_OpportunityID;
    }

    /* OppporID = this.state.isOppIDValidated
      ? this.state.OppID
      : this.props.Evt[0].Event_OpportunityID; */

    var EvtFeedback =
      this.state.EvtFeedback != undefined
        ? this.state.EvtFeedback
        : this.props.Evts[0].Event_Feedback;

    var EvtDataPost = {
      EventID: this.props.Evts[0].Event_ID,
      MMContentID: null,
      Type: "Event",
      Feeedback: EvtFeedback,
      OppID: OppporID,
    };

    var endpoint = "/AllContent/UpdateRecentEvtMM";
    let token = auth.getToken();
    // var postData = RatingDataPost;
    console.log("Event Post Data is :", EvtDataPost);
    this.setState({ showLoaderEvtSubmit: true });
    //start below
    callApiPostJson(endpoint, EvtDataPost, token).then((data) => {
      console.log("Evt update response from API:", data);
      if (data) {
        console.log("UpdateMessage back from Evt Update Call response is : ");
        console.log(data);
        this.setState({ isEvtSubmitted: true, showLoaderEvtSubmit: false });
      }
    });
  }

  submitMMUpdate() {
    console.log("Event ID is ", this.props.MMs[0].Event_ID);
    console.log("Submit Type is Multimedia");
    //console.log("Event Opp ID is ", this.state.OppID);
    console.log("Multimedia Feedback is ", this.state.MM.MContent_Feedback);

    let MMFeedback =
      this.state.MMFeedback != undefined || this.state.MMFeedback != null
        ? this.state.MMFeedback
        : this.props.MMs[0].MContent_Feedback;

    var MMDataPost = {
      EventID: null,
      MMContentID: this.props.MMs[0].AccessLog_ContentID,
      Type: "Multimedia",
      Feeedback: MMFeedback,
      OppID: null,
    };

    var endpoint = "/AllContent/UpdateRecentEvtMM";
    let token = auth.getToken();
    // var postData = RatingDataPost;
    console.log("Multimedia Update Post Data is :", MMDataPost);
    this.setState({ showLoaderMMSubmit: true });
    //start below
    callApiPostJson(endpoint, MMDataPost, token).then((data) => {
      console.log("MM update response from API:", data);
      if (data) {
        console.log("UpdateMessage back from MM Update Call response is : ");
        console.log(data);
        this.setState({ isMMSubmitted: true, showLoaderMMSubmit: false });
      }
    });
  }

  setRatingEvt(newRate, type, id, rating) {
    // console.log("Rating Prop is ", this.props._demo);
    console.log("Rating new Values is ", newRate);
    console.log("Rating new Values Type ", type);
    console.log("Rating new Values ID ", id);
    console.log("Rating  Curent Rate is ", rating);

    if (newRate !== null) {
      // console.log("Rating content Index Val is ", this.props.indexval);

      // var tempdemoData  = this.state.Demo;
      var ActionType = "";
      if (
        this.props.Evts[0].Rating_Value !== null &&
        this.props.Evts[0].Rating_Value > 0
      ) {
        ActionType = "Update";
      } else {
        ActionType = "Insert";
      }

      var RatingDataPost = {
        Rating_ID: null,
        ContentId: id,
        Rating_Value: newRate,
        Action_Type: ActionType,
        Content_Type: type,
      };

      var endpoint = "/AllContent/AddorUpdateRating";
      let token = auth.getToken();
      var postData = RatingDataPost;
      console.log("Rating Data is :", RatingDataPost);
      this.setState({ showLoaderRating: true });
      //start below
      callApiPostJson(endpoint, postData, token).then((data) => {
        console.log(
          "Profile result Rating insert update response from API:",
          data
        );
        if (data) {
          console.log("UpdateMessage back from Rating Call response is : ");
          console.log(data);

          //  this.props.hide();
          var tempEvtData = this.state.Evt;

          if (tempEvtData != undefined) {
            tempEvtData.Rating_Value = newRate;
            /*           tempdemoData.map((demoitem) => {
              if(demoitem.Content_ID == contentID){
                demoitem.Content_Rating = newRate;
              }
            }); */
            this.setState({ Evt: tempEvtData, showLoaderRating: false });
          }

          //this.setState({ Demo: tempdemoData, showLoaderRating: false });
          // auth.updateUserInfo(data);
          // this.props.hidenaa();
          // this.props.history.push("/home");
          //this.props.router.replace("/home");
        } else {
          this.setState({ showLoaderRating: false });
        }
      });
    } else {
      console.log(
        "No Action - As rating value not changed from previous value"
      );
    }
  }

  setRatingMM(newRate, type, id, rating) {
    // console.log("Rating Prop is ", this.props._demo);
    console.log("Rating new Values is ", newRate);
    console.log("Rating new Values Type ", type);
    console.log("Rating new Values ID ", id);
    console.log("Rating  Curent Rate is ", rating);

    if (newRate !== null) {
      // console.log("Rating content Index Val is ", this.props.indexval);

      // var tempdemoData  = this.state.Demo;
      var ActionType = "";
      if (
        this.props.MMs[0].Rating_Value !== null &&
        this.props.MMs[0].Rating_Value > 0
      ) {
        ActionType = "Update";
      } else {
        ActionType = "Insert";
      }

      var RatingDataPost = {
        Rating_ID: null,
        ContentId: id,
        Rating_Value: newRate,
        Action_Type: ActionType,
        Content_Type: type,
      };

      var endpoint = "/AllContent/AddorUpdateRating";
      let token = auth.getToken();
      var postData = RatingDataPost;
      console.log("Rating Data is :", RatingDataPost);
      this.setState({ showLoaderRatingMM: true });
      //start below
      callApiPostJson(endpoint, postData, token).then((data) => {
        console.log(
          "Profile result Rating insert update response from API:",
          data
        );
        if (data) {
          console.log("UpdateMessage back from Rating Call response is : ");
          console.log(data);

          //  this.props.hide();
          var tempMMData = this.state.MM;

          if (tempMMData != undefined) {
            tempMMData.Rating_Value = newRate;
            /*           tempdemoData.map((demoitem) => {
              if(demoitem.Content_ID == contentID){
                demoitem.Content_Rating = newRate;
              }
            }); */
            this.setState({
              MM: tempMMData,
              isMMSubmitted: true,
              showLoaderRatingMM: false,
            });
          }

          //this.setState({ Demo: tempdemoData, showLoaderRating: false });
          // auth.updateUserInfo(data);
          // this.props.hidenaa();
          // this.props.history.push("/home");
          //this.props.router.replace("/home");
        } else {
          this.setState({ showLoaderRatingMM: false });
        }
      });
    } else {
      console.log(
        "No Action - As rating value not changed from previous value"
      );
    }
  }

  render() {
    var OppIDVal =
      this.props.Evts != null || this.props.Evts != undefined
        ? this.props.Evts[0].Event_OpportunityID
        : null;

    var OppIDValidateColor = "brand";
    OppIDValidateColor = this.state.oppIDMessage.includes("GREAT") //&& this.state.isOppIDValidated
      ? "brand"
      : "brand";
    OppIDValidateColor = this.state.oppIDMessage.includes("FAILED")
      ? "red"
      : "brand";

    console.log("Opp ID Validation Message ", this.state.oppIDMessage);
    console.log("Opp ID Alert Status ", this.state.showOppIDAlert);
    console.log("Opp ID  Validated ", this.state.isOppIDValidated);

    var EvtSubmit = this.state.EvtFeedback != undefined ? false : true;

    console.log("Event updated submitted ", this.state.isEvtSubmitted);
    console.log("Multimedia updated submitted ", this.state.isMMSubmitted);

    if (this.state.isMMSubmitted && this.state.isEvtSubmitted) {
      console.log("All submitted");
      this.props.hide();
    }

    if (this.props.Evts == null && this.state.isMMSubmitted) {
      console.log("No Evts and MM  submitted");
      this.props.hide();
    }

    if (this.props.MMs == null && this.state.isEvtSubmitted) {
      console.log("No MMs and Evt  submitted");
      this.props.hide();
    }

    console.log("Any Event ", this.props.Evts);
    console.log("Any MM ", this.props.MMs);

    return (
      <Layer
        animate
        modal
        position="center"
        onEsc={this.props.hide}
        // full="horizontal"
        // margin="medium"
      >
        <Box
          // fill="horizontal"
          // align="stretch"
          // margin="medium"
          justify="start"
          background={{ color: "active-background" }}
          overflow={{ horizontal: "hidden", vertical: "auto" }}
        >
          {this.showOppIDAlert &&
            this.isOppIDValidated &&
            // this.state.OppID !== undefined &&
            this.state.oppIDMessage === "FAILED" &&
            OppIDValidateColor ===
              "red"(
                <Alert
                  severity="error"
                  onClose={this.closeOppIDALert}
                  color="red"
                >
                  Opportunity ID Validated succesfully.
                </Alert>
              )}

          <Main
            overflow={{ horizontal: "hidden", vertical: "auto" }}
            flex
            align="stretch"
            justify="start"
            margin={{ top: "medium", bottom: "small" }}
          >
            <Box align="stretch" justify="center" flex="grow" direction="row">
              <Box
                align="stretch"
                justify="start"
                flex="grow"
                pad={{ horizontal: "large", vertical: "medium" }}
                gap="medium"
                basis="xlarge"
                elevation="medium"
                round="xsmall"
                background={{ color: "active-background" }}
              >
                <Box
                  align="center"
                  justify="center"
                  direction="row"
                  gap="medium"
                  fill="horizontal"
                  margin={{ top: "medium" }}
                >
                  <Button
                    icon={<Close />}
                    secondary
                    onClick={this.props.hide}
                    margin="small"
                  />
                  {this.showOppIDAlert &&
                    !this.isOppIDValidated &&
                    //this.state.OppID !== undefined &&
                    this.state.oppIDMessage === "FAILED" && (
                      <Alert
                        severity="error"
                        onClose={this.closeOppIDALert}
                        color="green"
                      >
                        Opportunity ID Validation FAILED.
                      </Alert>
                    )}
                </Box>
                <Box align="center" justify="center">
                  <Text
                    size="medium"
                    weight="bold"
                    //align="center"
                    // justify="center"
                    margin={{ left: "medium", right: "medium" }}
                  >
                    Please provide rating, feedback and missing OppID for last
                    accessed content
                  </Text>
                </Box>

                <Box
                  align="center"
                  alignContent="center"
                  justify="center"
                  margin={{ left: "medium", right: "medium" }}
                >
                  <Grid
                    columns="medium"
                    fill={false}
                    pad="xsmall"
                    gap="medium"
                    justify="stretch"
                    justifyContent="stretch"
                    alignContent="stretch"
                  >
                    {this.state.Evt != undefined &&
                      !this.state.isEvtSubmitted && (
                        <Card justify="stretch" background={{ color: "white" }}>
                          <Box
                            align="left"
                            justify="left"
                            direction="row"
                            responsive={false}
                            pad="xsmall"
                            gap="small"
                            round="xsmall"
                            background={{ opacity: "medium" }}
                          >
                            <Box align="left" justify="left" direction="column">
                              <Text
                                weight="normal"
                                color="black"
                                truncate={false}
                                size="medium"
                              >
                                {this.props.Evts[0].Event_Title}
                              </Text>
                            </Box>
                          </Box>
                          <Box
                            align="stretch"
                            justify="stretch"
                            direction="row"
                            responsive={false}
                            pad="xsmall"
                          >
                            <Box
                              align="left"
                              justify="left"
                              direction="row"
                              margin={{ right: "large" }}
                            >
                              {this.props.Evts[0].PContent_Category ===
                                "Live" && (
                                <Console size="medium" color="brand" />
                              )}
                              {this.props.Evts[0].PContent_Category ===
                                "Lab" && (
                                <Codepen size="medium" color="blue!" />
                              )}
                              {this.props.Evts[0].PContent_Category ===
                                "Interactive" && (
                                <Gateway size="medium" color="purple!" />
                              )}
                              <Text color="black" margin={{ left: "small" }}>
                                {this.props.Evts[0].PContent_Category} - Demo
                              </Text>
                            </Box>
                            <Box
                              align="right"
                              justify="right"
                              direction="row"
                              margin={{ left: "lerge" }}
                            >
                              <Text size="small" margin={{ right: "medium" }}>
                                Event ID : {this.props.Evts[0].Event_ID}
                              </Text>
                              <Text size="small" margin={{ left: "medium" }}>
                                {new Date(
                                  this.props.Evts[0].Event_StartDate
                                ).toUTCString()}
                              </Text>
                            </Box>
                          </Box>
                          <Box
                            align="stretch"
                            justify="start"
                            background={{ color: "light-2" }}
                            pad="small"
                            border={{ style: "inset" }}
                            direction="column"
                          >
                            <Text size="small">Please rate (star)</Text>
                            {this.state.showLoaderRating && (
                              <ScaleLoader
                                color="#008000"
                                height={20}
                                speedMultiplier={2}
                                width={5}
                              />
                            )}
                            <Rating
                              name={this.props.Evts[0].Event_ID}
                              style={{ color: "green" }}
                              value={
                                this.state.Evt != undefined
                                  ? this.state.Evt.Rating_Value
                                  : this.props.Evts.Rating_Value
                              }
                              onChange={(event, newvalue) => {
                                this.setRatingEvt(
                                  newvalue,
                                  "Physical",
                                  this.props.Evts[0].PhysicalContentID,
                                  this.props.Evts[0].Rating_Value
                                );
                              }}
                            />
                            <br />
                            <TextInput
                              plain={false}
                              // margin={{ top: "medium" }}
                              placeholder="Enter Your Feedback "
                              value={this.state.Evt.Event_Feedback}
                              disabled={this.state.isEvtSubmitted}
                              onChange={(event) =>
                                this.handleFeedbackEvt(event.target.value)
                              }
                            />
                          </Box>
                          <Box
                            align="center"
                            justify="center"
                            direction="row"
                            gap="medium"
                            pad="small"
                            background={{ color: "light-2" }}
                            border={{ style: "inset" }}
                          >
                            <TextInput
                              placeholder="Enter SalesForce Oppotunity: OPE-XXXXXX"
                              value={OppIDVal}
                              disabled={this.state.isOppIDValidated}
                              onChange={(event) =>
                                this.handleOppID(event.target.value)
                              }
                            />
                            <Button
                              label={
                                this.state.OppIDvalidatedLoader ? (
                                  <Box
                                    direction="row"
                                    gap="small"
                                    justify="center"
                                    align="center"
                                  >
                                    <Spinner size="small" color="brand" />{" "}
                                    {/* <Text>Saving User Info..</Text> */}
                                  </Box>
                                ) : (
                                  ""
                                )
                              }
                              primary={false}
                              hoverIndicator
                              active
                              success={false}
                              secondary={false}
                              reverse={false}
                              onClick={this.validateOppID}
                              icon={<Validate color={OppIDValidateColor} />}
                            />
                          </Box>
                          <Box align="center" justify="center" pad="small">
                            <Button
                              label={
                                this.state.showLoaderEvtSubmit ? (
                                  <Box
                                    direction="row"
                                    gap="small"
                                    justify="center"
                                    align="center"
                                  >
                                    <Spinner size="small" color="brand" />{" "}
                                    {/* <Text>Saving User Info..</Text> */}
                                  </Box>
                                ) : (
                                  ""
                                )
                              }
                              icon={<Return />}
                              // active={false}
                              primary
                              secondary
                              onClick={this.submitEvtUpdate}
                              disabled={
                                this.state.isEvtSubmitted //&&
                                // !this.state.isOppIDValidated &&
                                // EvtSubmit
                              }
                              reverse={false}
                            />
                          </Box>
                        </Card>
                      )}
                    {this.state.MM != undefined &&
                      !this.state.isMMSubmitted && (
                        <Card
                          justify="start"
                          background={{ color: "white" }}
                          height="100%"
                        >
                          <Box
                            align="stretch"
                            justify="start"
                            direction="row"
                            responsive={false}
                            pad="xsmall"
                            gap="small"
                            round="xsmall"
                            background={{ opacity: "medium" }}
                          >
                            <Box
                              align="center"
                              justify="start"
                              direction="column"
                            >
                              <Text
                                weight="normal"
                                color="black"
                                truncate={false}
                                size="medium"
                              >
                                {this.props.MMs[0].MContent_Title}
                              </Text>
                            </Box>
                          </Box>
                          <Box
                            align="stretch"
                            justify="between"
                            direction="row"
                            responsive={false}
                            pad="xsmall"
                          >
                            <Box
                              align="center"
                              justify="center"
                              direction="row"
                            >
                              <Video size="medium" color="blue" />
                              <Text color="black" margin={{ left: "small" }}>
                                {this.props.MMs[0].AccessLog_ContentType}
                              </Text>
                            </Box>
                            <Box align="stretch" justify="start">
                              <Text size="small">Last Accessed : </Text>
                              <Text size="small">
                                {new Date(
                                  this.props.MMs[0].AddedDate
                                ).toUTCString()}
                              </Text>
                            </Box>
                          </Box>
                          <Box
                            align="stretch"
                            justify="start"
                            background={{ color: "light-2" }}
                            pad="small"
                            border={{ style: "inset" }}
                            direction="column"
                          >
                            <Text size="small">Please rate (star)</Text>
                            {this.state.showLoaderRatingMM && (
                              <ScaleLoader
                                color="#008000"
                                height={20}
                                speedMultiplier={2}
                                width={5}
                              />
                            )}
                            <Rating
                              name={this.props.MMs[0].AccessLog_ContentID}
                              style={{ color: "green" }}
                              value={
                                this.state.MM != undefined
                                  ? this.state.MM.Rating_Value
                                  : this.props.MMs[0].Rating_Value
                              }
                              onChange={(event, newvalue) => {
                                this.setRatingMM(
                                  newvalue,
                                  "Multimedia",
                                  this.props.MMs[0].AccessLog_ContentID,
                                  this.props.MMs[0].Rating_Value
                                );
                              }}
                            />
                            <br />
                            <br />
                            <br />

                            {/* <TextInput
                            plain={false}
                            placeholder="Enter Your Feedback "
                            value={this.state.MM.MContent_Feedback}
                            // disabled={this.state.isOppIDValidated}
                            onChange={(event) =>
                              this.handleFeedbackMM(event.target.value)
                            }
                          /> */}
                            <br />
                            <br />
                            <br />
                          </Box>
                        </Card>
                      )}
                  </Grid>
                </Box>
              </Box>
            </Box>
          </Main>
        </Box>
      </Layer>
    );
  }
}
export default RatingFeedback;
